import { IconButton } from "@mui/material";
import { AddButton } from "app/components/Button/AddButton";
import { FilterSelect } from "app/components/FilterSelect";
import { ThreedotIcon } from "app/icons";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { selectStatusFilter } from "../../redux/selector";
import { actions } from "../../redux/slice";
import { StatusFilter } from "../../types";
import { useStyles } from "./styles";

const STATUS_OPTIONS: StatusFilter[] = [
  "ALL",
  "IN_PRODUCTION",
  "WAITING_ENGINEERING",
  "QUALITY_CONTROL",
];

const ActionBar = () => {
  const { t } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();
  const statusFilter = useSelector(selectStatusFilter);

  const getStatusLabel = (value: StatusFilter) =>
    t(
      value === "ALL"
        ? "WORK_ORDER.STATUS_ALL"
        : `WORK_ORDER.STATUS_VALUES.${value}`
    );

  return (
    <div className={styles.root} dir="ltr">
      <div className={styles.actions}>
        <AddButton label={t("WORK_ORDER.ADD")} />
        <IconButton size="small" className={styles.iconButton}>
          <ThreedotIcon />
        </IconButton>
      </div>

      <FilterSelect
        label={t("WORK_ORDER.STATUS_FILTER")}
        value={statusFilter}
        options={STATUS_OPTIONS}
        getOptionLabel={getStatusLabel}
        onChange={(value) => dispatch(actions.setStatusFilter(value))}
      />
    </div>
  );
};

export default ActionBar;
